import { PayeasyDetailType } from "@graffer-inc/cloud-gov-core";
import { formatOnlyDate } from "../../../../../utils/date-utils";

export type PayeasyDetailProps = {
  payeasyDetail: PayeasyDetailType;
};

const PayeasyDetailItem: React.FC<{
  label: string;
  value: string;
}> = ({ label, value }) => {
  return (
    <div className="columns is-paddingless is-marginless is-mobile">
      <div className="column is-3">{label}</div>
      <div className="column has-text-weight-bold">{value}</div>
    </div>
  );
};

export const PayeasyDetail: React.FC<PayeasyDetailProps> = ({
  payeasyDetail,
}) => {
  return (
    <div className="payeasy">
      <PayeasyDetailItem label="収納機関番号" value={payeasyDetail.skNo} />
      <PayeasyDetailItem label="お客様番号" value={payeasyDetail.customerNum} />
      <PayeasyDetailItem
        label="確認番号"
        value={payeasyDetail.confirmationNum}
      />
      <PayeasyDetailItem
        label="お支払い期限"
        value={formatOnlyDate(payeasyDetail.billDate)}
      />
    </div>
  );
};
